import React, { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { ExampleModal } from "./CarouselExampleModal";
import { EyeIcon } from "../../../../assets/EyeIcon";
import ButtonExample from "../../../../assets/ButtonExample.png";

interface SlideButtonSectionProps {
    buttonText: string;
    buttonUrl: string;
    buttonBackgroundColor: string;
    buttonTextColor: string;
    showButton: boolean;
    imageUrlEnabled: boolean;
    isRestricted: boolean;
    onFieldChange: (id: string, value: string) => void;
    onShowButtonChange: (enabled: boolean) => void;
}

export const CarouselSlideEditorButtonSection: React.FC<SlideButtonSectionProps> = ({
    buttonText,
    buttonUrl,
    buttonBackgroundColor,
    buttonTextColor,
    showButton,
    imageUrlEnabled,
    isRestricted,
    onFieldChange,
    onShowButtonChange,
}) => {
    const [showExample, setShowExample] = useState(false);
    const isDisabled = isRestricted || imageUrlEnabled;
    const disabledReason = isRestricted
        ? "You don't have permission to edit this section."
        : imageUrlEnabled
            ? "Disable the image URL to use the button."
            : "";

    return (
        <Tooltip
            title={isDisabled ? disabledReason : ""}
            disableHoverListener={!isDisabled}
            arrow
        >
            <section
                className={`editSection editSection--button ${imageUrlEnabled ? "disabled" : ""}`}
            >
                <div className="editSection__head">
                    <div className="title">Button</div>
                    <button type="button" className="seeExample" onClick={() => setShowExample(true)}>
                        <span className="eyeIcon" />See Example <EyeIcon />
                    </button>
                </div>

                <p>Add a Button</p>

                <div className="btnInputs2">
                    <div className="btnRow">
                        <div className="field">
                            <input
                                id="a"
                                type="text"
                                className="input-round form-control"
                                placeholder="Text example: SHOP NOW"
                                value={buttonText}
                                onChange={(e) => onFieldChange("a", e.target.value)}
                                disabled={isDisabled}
                            />
                        </div>
                        <div className="colorRow">
                            <div className="colorItem">
                                <span>Background color</span>
                                <input
                                    id="buttonBackgroundColor"
                                    type="color"
                                    value={buttonBackgroundColor}
                                    onChange={(e) => onFieldChange("buttonBackgroundColor", e.target.value)}
                                    disabled={isDisabled}
                                />
                            </div>
                            <div className="colorItem">
                                <span>Text color</span>
                                <input
                                    id="buttonTextColor"
                                    type="color"
                                    value={buttonTextColor}
                                    onChange={(e) => onFieldChange("buttonTextColor", e.target.value)}
                                    disabled={isDisabled}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="field withIcon">
                        <input
                            id="url"
                            type="text"
                            className="input-round form-control link"
                            placeholder="URL of the button: http://"
                            value={buttonUrl !== "#" ? buttonUrl : ""}
                            onChange={(e) => onFieldChange("url", e.target.value)}
                            disabled={isDisabled}
                        />
                    </div>
                    <div className="imageUrlSwitch">
                        <p className="hint">Use the button instead of the URL in the image.</p>
                        <div className="enable-button">
                            <p>Enable</p>
                            <input
                                id="showButton"
                                type="checkbox"
                                checked={!!showButton}
                                onChange={(e) => onShowButtonChange(e.target.checked)}
                                disabled={isDisabled}
                            />
                        </div>
                    </div>
                </div>

                <ExampleModal
                    title=""
                    imageSrc={ButtonExample}
                    open={showExample}
                    onClose={() => setShowExample(false)}
                />
            </section>
        </Tooltip>
    );
};